const inFlightRequests = new Map<string, Promise<any>>();
const resolvedRequests = new Map<string, any>();

const buildShortlistPriceBreakupUrl = ({
  variantSlug,
  cityName,
  colorSlug = "",
}: {
  variantSlug: string;
  cityName: string;
  colorSlug?: string;
}) =>
  `/api/price-breakup-v2/?slug=${encodeURIComponent(
    variantSlug,
  )}&city=${encodeURIComponent(cityName)}&color=${encodeURIComponent(
    colorSlug,
  )}`;

export const fetchShortlistPriceBreakup = ({
  variantSlug,
  cityName,
  colorSlug,
}: {
  variantSlug: string;
  cityName: string;
  colorSlug?: string;
}): Promise<any> => {
  const url = buildShortlistPriceBreakupUrl({
    variantSlug,
    cityName,
    colorSlug,
  });
  const cached = resolvedRequests.get(url);
  if (cached) {
    return Promise.resolve(cached);
  }

  const existing = inFlightRequests.get(url);

  if (existing) {
    return existing;
  }

  const promise = fetch(url)
    .then((res) => {
      if (!res.ok) {
        throw new Error(`HTTP ${res.status}`);
      }

      return res.json();
    })
    .then((data) => {
      resolvedRequests.set(url, data);
      return data;
    })
    .finally(() => {
      inFlightRequests.delete(url);
    });

  inFlightRequests.set(url, promise);

  return promise;
};

export const fetchCachedPriceBreakupV2 = fetchShortlistPriceBreakup;
